import { useSelector } from 'react-redux';
import { useFlags } from 'flagsmith/react';

export function useScheduleMessage() {
  const currentCustomer = useSelector(
    (state: any) => state?.chat?.config?.user?.current_customer_id
  ) as number;

  const { enabled, value } = useFlags(['schedule_message']).schedule_message as {
    enabled: boolean;
    value: string;
  };

  return {
    scheduleMessageFlag:
      enabled && value?.includes(String(currentCustomer)),
  };
}